<template>
    <div class="justifyContentBOX">
        <b-field class="commonrules-grp cost-unit-input" label="Flight total cost exceeds the benchmark fare by">
            <b-input type="number" v-model="obj.cost" @input="updateLowestLogicalAirfare" class="ml-2 nmbr-input" />
            <b-select v-model="obj.unit" @input="changeUnits">
                <option v-for="amountType in amountTypes" :key="amountType" :value="amountType">
                    {{ amountType }}
                </option>
            </b-select>
        </b-field>

        <div class="box mt-3">

            <p class="is-italic my-3">Benchmark fare calculation criteria</p>

            <b-field class="mt-3">
                <b-checkbox type="is-primary" v-model="isExceptionAirlines">
                    <b-field label="Configure specific airlines to use or not use when calculating the benchmark fare"></b-field>
                </b-checkbox>
            </b-field>
            <section v-if="isExceptionAirlines" class="mb-5">
                <b-field class="commonrules-grp">
                    <b-select v-model="obj.exception" @input="updateLowestLogicalAirfare">
                        <option value="" disabled>Select..</option>
                        <option v-for="option in exceptionOptions" :key="option" :value="option">
                            {{ exceptionString(option) }}
                        </option>
                    </b-select>
                    
                </b-field>
                <b-field class="my-3">
                    <AirlineNameSelector placeholder="e.g. American Airlines" icon="magnify" :choices="getAirlineCodes"
                            :selected="obj.exceptionAirlines" @list="updateLowestLogicalAirfare"></AirlineNameSelector>
                </b-field>
            </section>
            
            <b-field class="">
                <b-checkbox type="is-primary" v-model="obj.isRefundable" @input="updateLowestLogicalAirfare">
                    <b-field
                        label="Only include refundable fares when calculating the benchmark fare"></b-field>
                </b-checkbox>
            </b-field>

        </div>
    </div>
</template>
<script>
import { relativeTimeThreshold } from 'moment';

import AirlineNameSelector from '../../Tags/AirlineNameSelector.vue';
export default {
    name: "LowestLogicalAirfare",
    props: {
        fareOptions: null
    },
    components: { AirlineNameSelector },
    data() {
        return {
            obj: {
                exceptionAirlines: [],
                exception: '',
                isRefundable: false,
                cost: '',
                unit: ''
            },
            amountTypes: ['percent', 'dollars'],
            isExceptionAirlines: false,
            exceptionOptions: ['in', 'not_in']
        }
    },
    computed: {
        getAirlineCodes() {
            return Object.entries(this.$store.state.bookTravel.vendors.airlines).map(([key, value]) => ({ key, value }));
        },
    },
    methods: {
        updateLowestLogicalAirfare(val) {
            this.$emit('lowestLogicalAirfare', this.obj)
        },
        changeUnits(val) {
            this.$emit('lowestLogicalAirfare', this.obj)
        },
        getAirline(val) {
            return this.$helpers.airlineName(val)
        },
        exceptionString(val) {
            if (val == "in") {
                return 'Only use the following airlines'
            } else {
                return 'Exclude the following airlines'
            }
        },
        toggleRefund() {
            this.$emit('lowestLogicalAirfare', this.obj);
        }
    },
    watch: {
        isExceptionAirlines(val) {
            if (!val) {
                this.obj.exceptionAirlines = []
            }
        }
    },
    mounted() {
        this.obj.cost = this.fareOptions.amountVal;
        this.obj.unit = this.fareOptions.amountType;
        this.obj.exception = this.fareOptions.exceptionVal;
        this.obj.isRefundable = this.fareOptions.isRefund;
        //Convert string into array of airlines and convert the codes into airline names
        if (this.fareOptions.airlines) {
            let _airlineArr = this.fareOptions.airlines.split(",")
            _airlineArr = _airlineArr.map(this.getAirline)
            this.obj.exceptionAirlines = _airlineArr
            this.isExceptionAirlines = true;
        }

    }
}
</script>
<style scoped>
.nmbr-input {
    width: 100%;
}
@media screen and (min-width: 768px) {
  .nmbr-input {
    width: 20%;
  }

}
</style>
